import { render } from "./Excel.vue?vue&type=template&id=4c77454b&scoped=true"
import script from "./Excel.vue?vue&type=script&lang=js"
export * from "./Excel.vue?vue&type=script&lang=js"

import "./Excel.vue?vue&type=style&index=0&id=4c77454b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c77454b"]])

export default __exports__